import { CommentSVG, ShareSVG } from "../../svg";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";
import LegacyLink from "../../components/link/LegacyLink";
import RouterLink from "../../components/link/RouterLink";
import Tag from "../tag/tag";
import LegacyThumbnail from "../legacyThumbnail/legacyThumbnail";
import ArticleCardAuthorRow from "../articleCardComponents/articleCardAuthorRow";

import { useSingleArticleTypeByDatasource } from "../../hooks/useStoryblokArticleTypes";
import { useStoryblokGlobalSettings } from "../../hooks/useStoryblokGlobalSettings";

import { formatArticleDate } from "../../helpers/dateHelper";
import {
  articleUrlFromSlug,
  buildInternalPath,
} from "../../helpers/URLHelpers";

import styles from "./ArticleAsideCard.module.scss";

function ArticleAsideCard({
  slug,
  thumbnail,
  authors,
  title,
  date,
  article_type_key,
  enable_comments,
  comment_count,
  enable_social_sharing,
  use_legacy_thumbnail_background,
}) {
  const articleType = useSingleArticleTypeByDatasource(article_type_key);
  const globalSettings = useStoryblokGlobalSettings();
  const link = articleUrlFromSlug(slug);

  if (!thumbnail || !thumbnail.filename) {
    thumbnail = globalSettings.thumbnail_default_image;
  }

  return (
    <article className={`${styles.articleAsideCard} ${styles.defaultLayout}`}>
      {articleType ? (
        <div className={styles.tagsMobile}>
          {articleType ? (
            <LegacyLink story_uuid={articleType.uuid}>
              <Tag label={articleType.name} />
            </LegacyLink>
          ) : null}
        </div>
      ) : null}
      <div className={styles.articleDetails}>
        <div>
          <div className={styles.thumbnail}>
            {use_legacy_thumbnail_background ? (
              <LegacyThumbnail
                to={slug}
                thumbnail_image={thumbnail}
                width={160}
              />
            ) : (
              <>
                {thumbnail && thumbnail.filename ? (
                  <RouterLink className={styles.defaultThumbnail} to={link}>
                    <StoryblokImageBasic width={160} image={thumbnail} />
                  </RouterLink>
                ) : null}
              </>
            )}
          </div>
          <div className={styles.actions}>
            {enable_social_sharing ? (
              <button
                className={`limit-visibility hidden flex-center-children ${styles.share}`}
              >
                <ShareSVG />
              </button>
            ) : null}
            {enable_comments ? (
              <button
                className={`limit-visibility hidden flex-center-children ${styles.comments}`}
              >
                {comment_count}
                <CommentSVG />
              </button>
            ) : null}
          </div>
        </div>
        <div>
          {articleType ? (
            <div className={styles.tags}>
              {articleType ? (
                <LegacyLink story_uuid={articleType.uuid}>
                  <Tag withClass={styles.tag} label={articleType.name} />
                </LegacyLink>
              ) : null}
            </div>
          ) : null}
          {date ? (
            <div className={styles.date}>{formatArticleDate(date)}</div>
          ) : null}
          {title ? (
            <RouterLink className={styles.title} to={link}>
              <h3>{title}</h3>
            </RouterLink>
          ) : null}
          <ArticleCardAuthorRow
            authors={authors}
            commentCount={comment_count}
            enableSocialSharing={false} //these are shown under the image
            enableComments={false}
          />
        </div>
      </div>
    </article>
  );
}

export default ArticleAsideCard;
